import _regeneratorRuntime from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import Vue from 'vue';
import helper from '@/libs/helper.js';
import axios from '@/plugin/axios';
import pluginExport from '@d2-projects/vue-table-export';
import sheet from "@/libs/sheet.js";
import util from '@/libs/util';
Vue.use(pluginExport);
export default {
  data: function data() {
    return _defineProperty(_defineProperty({
      filename: __filename,
      currentPeriodStr: '',
      currentPeriodData: {
        huobizijin: '--',
        yingshouzhangkuan: '--',
        cunhuo: '--',
        gudingzichan: '--',
        yingfuzhangkuan: '--'
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      selectDate: [helper.formatDayStr(), helper.formatDayStr()],
      selectDate1: [helper.formatDayStr(-7), helper.formatDayStr()],
      tableData: [],
      guanjianData: {
        addnum: 0,
        manNum: 0,
        unnormalList: [],
        unnormalNum: 0,
        womanNum: 0
      },
      data_updatetime: "--",
      currentPeriod: '',
      selectedPeriod: '',
      selectedDate: '',
      canGoLeft: false,
      canGoRight: false,
      showYear: false,
      quota: {},
      monthQuota: {
        zonghefushuilv: '- -',
        yingjiaoshuifei: '- -',
        yingyeshouru: '- -',
        lirun: '- -',
        lirunlv: '- -'
      },
      yearQuota: {
        zonghefushuilv: '- -',
        yingjiaoshuifei: '- -',
        yingyeshouru: '- -',
        lirun: '- -',
        lirunlv: '- -'
      },
      currentYear: '0',
      currentMonth: '0',
      max_date: '',
      min_date: '',
      current_date: '',
      loading: true,
      admin: null,
      system_name: '',
      time_text: '',
      school_count: 0,
      student_count: 0,
      order_num: 0,
      order_num_7_day: 0
    }, "tableData", []), "active_name", '');
  },
  created: function created() {
    //this.loadGuanjian();
    //this.loadAreaList();
    this.loadData('', '');
    this.quota = this.monthQuota;
  },
  methods: {
    pickChange: function pickChange(e) {
      console.log('pickchange e:');
      this.selectDate = [helper.formatDayStr(0, e[0]), helper.formatDayStr(0, e[1])];
      console.log("selectDate", this.selectDate);
      this.loadGuanjian();
    },
    pickChange1: function pickChange1(e) {
      console.log('pickchange1 e:');
      this.selectDate1 = [helper.formatDayStr(0, e[0]), helper.formatDayStr(0, e[1])];
      console.log("selectDate1", this.selectDate1);
      this.loadAreaList();
    },
    outputUnnormal: function outputUnnormal() {
      var _this = this;
      var columns = sheet.getHeader();
      this.$export.excel({
        columns: columns,
        data: this.guanjianData.unnormalList
      }).then(function () {
        _this.$message('导出表格成功');
      });
    },
    loadAreaList: function loadAreaList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, data, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = helper.apiHost + helper.apiUrl.indexAreaList;
              data = {
                admin_id: localStorage['admin_id'],
                addtime_start: _this2.selectDate1[0],
                addtime_end: _this2.selectDate1[1]
              };
              _context.next = 4;
              return axios({
                url: url,
                method: 'post',
                data: data
              });
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                _this2.tableData = res.data;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    loadGuanjian: function loadGuanjian() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var url, data, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              //加载关键数据
              url = helper.apiHost + helper.apiUrl.indexGuanjian;
              data = {
                admin_id: localStorage['admin_id'],
                addtime_start: _this3.selectDate[0],
                addtime_end: _this3.selectDate[1]
              };
              _context2.next = 4;
              return axios({
                url: url,
                method: 'post',
                data: data
              });
            case 4:
              res = _context2.sent;
              if (res.code == 0) {
                _this3.guanjianData = res.data;
                _this3.data_updatetime = res.data.data_updatetime;
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    loadData: function loadData(periodDate, dir) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var that, url, data, response, resData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = _this4;
              that.loading = true;
              url = helper.apiHost + helper.apiUrl.getIndexData;
              data = {
                period: periodDate,
                dir: dir
              };
              _context3.next = 6;
              return axios(url, {
                params: data
              });
            case 6:
              response = _context3.sent;
              that.loading = false;
              if (response.code == 0) {
                console.log('loadData:response', response);
                resData = response['data'];
                that.admin = resData['admin'];
                that.system_name = resData['system_name'];
                that.time_text = resData['time_text'];
                that.school_count = resData['school_count'];
                that.student_count = resData['student_count'];
                that.order_num = resData['order_num'];
                that.order_num_7_day = resData['order_num_7_day'];
                that.tableData = resData['tableData'];
                that.active_name = resData['active_name'];
              } else {}
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    showYearData: function showYearData() {
      if (!this.showYear) {
        this.showYear = true;
        this.quota = this.yearQuota;
      }
    },
    showMonthData: function showMonthData() {
      if (this.showYear) {
        this.showYear = false;
        this.quota = this.monthQuota;
      }
    },
    goLeftPeriod: function goLeftPeriod() {
      // console.log(this.current_date);
      if (this.canGoLeft) {
        this.loadData(this.current_date, 'last');
      }
    },
    goRightPeriod: function goRightPeriod() {
      // console.log(this.current_date);
      if (this.canGoRight) {
        this.loadData(this.current_date, 'next');
      }
    },
    checkVoucher: function checkVoucher() {
      this.$router.push('/voucher/index');
    },
    checkPeriod: function checkPeriod() {
      this.$router.push('/checkout');
    },
    checkBalance: function checkBalance() {
      this.$router.push('/subject_balance');
    },
    checkAsset: function checkAsset() {
      this.$router.push('/statement/balance_sheet');
    },
    checkProfit: function checkProfit() {
      this.$router.push('/statement/income_sheet');
    },
    addVoucher: function addVoucher() {
      this.$router.push('/voucher/form');
    },
    //--表格相关--
    //表头样式控制
    tableHeaderStyle: function tableHeaderStyle(row) {
      //console.log('tableHeaderStyle',row);
      return 'text-align: center;' + 'background-color: #CCE0FF;' + 'font-size:16px;' + 'color:#0044B1;' + 'border-color: #B0CEFF;';
    },
    //单元格样式控制
    tableCellStyle: function tableCellStyle(row) {
      //console.log('tableCellStyle-row',row);
      return 'height:20px;border-color: #B0CEFF;';
    },
    //表头class引用控制
    tableHeaderClass: function tableHeaderClass(_ref2) {
      var row = _ref2.row,
        rowIndex = _ref2.rowIndex;
      //console.log('tableHeaderClass');
      return 'table_title';
    },
    //单元格class引用控制
    tableCellClass: function tableCellClass(_ref3) {
      var row = _ref3.row,
        rowIndex = _ref3.rowIndex;
      return 'bg_color_2';
    },
    //--表格相关--
    /**
     * 打开订单列表
     */
    openOrderList: function openOrderList() {
      this.$router.push("/order");
    },
    /**
     * 打开学生列表
     */
    openStudentList: function openStudentList() {
      this.$router.push("/student");
    },
    /**
     * 打开院校列表
     */
    openSchoolList: function openSchoolList() {
      this.$router.push("/school");
    },
    /**
     * 打开学生编辑页
     * @param id
     */
    openStudentEdit: function openStudentEdit(id) {
      console.log('openStudentEdit');
      this.$router.push("/student/edit?id=" + id);
    }
  }
};